import {
    FETCH_DATA_SIGNUP_REQUEST,
    FETCH_DATA_SIGNUP_SUCCESS,
    FETCH_DATA_SIGNUP__FAILURE,
    CLEAR_DATA
} from '../../actions/signup/signup-actions';

const initialState = {
    data: null,
    isLoading: false,
    error: null,
};

const SignupReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_SIGNUP_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_SIGNUP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: { ...action.payload },
                error: null
            };
        case FETCH_DATA_SIGNUP__FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                data: null
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default SignupReducer;